module.exports = __webpack_public_path__ + "img/banner_index01.4ed37dc7.png";